import { render, staticRenderFns } from "./DragAndDropAnimation.vue?vue&type=template&id=12bbf0e0&"
import script from "./DragAndDropAnimation.vue?vue&type=script&lang=js&"
export * from "./DragAndDropAnimation.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDropAnimation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports